export default __webpack_public_path__ + "static/media/head02_zh_tw_pc.304ce919.png";